import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip as MuiTooltip } from '@mui/material'

const tooltipSx = {
  m: '0 !important', // khoảng cách tới anchor do popper offset quyết định
  px: 'var(--space-10)',
  py: 'var(--space-4)',
  maxWidth: 300,
  bgcolor: 'var(--color-bg-raised)',
  border: 'var(--stroke-default) solid var(--color-border-default)',
  borderRadius: 'var(--radius-sm)',
  boxShadow: 'none',
  fontFamily: 'var(--font-family-primary)',
  fontWeight: 'var(--font-weight-regular)',
  fontSize: 'var(--font-size-12)', // Caption/12 Regular
  lineHeight: 'normal',
  color: 'var(--color-text-primary)'
}

/**
 * Tooltip Type=Label (Figma 8:1944): hint 1 dòng khi hover — bg/raised + border/default, radius/sm, padding 4/10, Caption/12 Regular.
 * Bọc MUI Tooltip (`title`, `placement`, `children`... như MUI), không có mũi tên. Type=List xem `components/design-system/TooltipList`.
 */
const Tooltip = React.forwardRef(({ title, children, placement = 'bottom', slotProps, ...props }, ref) => (
  <MuiTooltip
    ref={ref}
    title={title}
    placement={placement}
    slotProps={{
      ...slotProps,
      tooltip: { ...slotProps?.tooltip, sx: [tooltipSx, slotProps?.tooltip?.sx ?? {}] },
      popper: { modifiers: [{ name: 'offset', options: { offset: [0, 4] } }], ...slotProps?.popper }
    }}
    {...props}
  >
    {children}
  </MuiTooltip>
))

Tooltip.displayName = 'Tooltip'

Tooltip.propTypes = {
  title: PropTypes.node,
  children: PropTypes.element.isRequired,
  placement: PropTypes.string,
  slotProps: PropTypes.object
}

export default Tooltip
